<template>
  <v-dialog v-model="isShowConditionModal" max-width="800" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">絞り込み条件</span>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex
            v-for="(condition, index) in tmpPoiSearchForm.conditions"
            :key="index"
            xs9
          >
            <SubcategoryItem
              :selectedPoiCategoryId="selectedPoiCategoryId"
              :poiSubCategory="condition"
              :index="index"
              @deleteCondition="deleteCondition"
              :poiSubCategoryList="getSelectablePoiSubCategoryList(condition)"
            />
          </v-flex>
          <v-flex xs12>
            <v-btn
              @click="addCondition"
              :disabled="isPlusButtonDisabled"
              fab
              color="primary"
              small
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeModal">
          キャンセル
        </v-btn>
        <v-btn @click="onClickSave" color="primary">
          登録
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { POICategoryRepository } from '@/models/POICategoryRepository'
import SubcategoryItem from './SubcategoryItem'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'SubcategoryListFormModal',
  components: {
    SubcategoryItem,
  },
  props: {
    poiSearchForm: {
      type: Object,
      default: () => {},
    },
    isShowConditionModal: {
      type: Boolean,
      default: false,
    },
    selectedPoiCategoryId: {
      type: [Number, undefined],
      default: 0,
    },
  },
  data() {
    return {
      poiSubCategoryList: [],
      tmpPoiSearchForm: cloneDeep(this.poiSearchForm),
    }
  },
  computed: {
    isConditionsFull() {
      return (
        this.tmpPoiSearchForm.conditions.length ===
        this.poiSubCategoryList.length
      )
    },
    isPoiSubCategoryListEmpty() {
      return this.poiSubCategoryList.length === 0
    },
    isPlusButtonDisabled() {
      return this.isConditionsFull || this.isPoiSubCategoryListEmpty
    },
    isConditionValuesEmpty() {
      return this.tmpPoiSearchForm.conditions.some(condition => {
        return (
          condition.poiSubCategoryId === null ||
          (condition.type === 'select' && condition.valueIds.length === 0) ||
          (condition.type === 'number' && condition.value === null)
        )
      })
    },
  },
  watch: {
    isShowConditionModal() {
      this.tmpPoiSearchForm = cloneDeep(this.poiSearchForm)
    },
    async selectedPoiCategoryId(val) {
      if (val) {
        this.poiSubCategoryList = await POICategoryRepository.getSubcategory(
          val,
        )
      }
    },
  },
  methods: {
    getSelectablePoiSubCategoryList(targetCondition) {
      const selectedSubCategoryIds = this.tmpPoiSearchForm.conditions
        .filter(condition => condition !== undefined)
        .map(condition => condition.poiSubCategoryId)
      return this.poiSubCategoryList.filter(subCategory => {
        return (
          subCategory.id === targetCondition.poiSubCategoryId ||
          !selectedSubCategoryIds.includes(subCategory.id)
        )
      })
    },
    addCondition() {
      this.tmpPoiSearchForm.addCondition()
    },
    deleteCondition(index) {
      this.tmpPoiSearchForm.removeCondition(index)
    },
    async onClickSave() {
      if (this.isConditionValuesEmpty) {
        await this.$confirm('入力エラー', {
          okText: '閉じる',
          onlyOk: true,
          body: '絞り込み条件を選択してください',
        })
        return
      }
      this.$emit('onClickSave', this.tmpPoiSearchForm)
      this.closeModal()
    },
    closeModal() {
      this.$emit('closeModal')
    },
  },
}
</script>
